
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class AddCandidate extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
		this.state = {
			manager_user: [],
			hiring_profile: [],
			hiring_status: [],
			fields: {
				candidate_profiles: 0,
			},
			errors: {},
			roles: {},
			invalid_ext: '',
			invalid_profile: '',
			link1: 1,
			link2: 0,
			link3: 0,
			multiSelect: [],
			selectedValues: [],
			name: [],
			value: 0,
			apiUrl: this.decryptconfigdata('apiUrl'),
			userAuthKey: has_local_data ? localdata.user_key : '',
			userId: has_local_data ? localdata.user_id : '',
			userEmail: has_local_data ? localdata.user_email : '',
		};
		this.onChange = this.onChange.bind(this);
		this.onLinkChange = this.onLinkChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
		var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
		var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}

	handleChange = (event, index, value) => {
		let fields = this.state.fields;
		this.setState({ value: value });
		fields['candidate_profiles'] = value.length;
	}

	spaceKeyPress(event) {
		if (event.which == 32 && !event.target.value.length) {
			event.preventDefault();
		}
	}

	fileSelecthandler = (event) => {
		this.setState({ selectedFile: event.target.files[0] });
	}

	onChange(event) {
		let fields = this.state.fields;
		this.setState({ [event.target.name]: event.target.value });
		fields[event.target.name] = event.target.value;
		console.log(this.state.fields);
	}

	onLinkChange() {
		var selectedLinks = [];
		$("input.links").each(function () {
			selectedLinks.push($(this).val());
		});
		this.setState({ candidate_links: selectedLinks });
	}

	handleValidation() {
		let fields = this.state.fields;
		let errors = {};
		let formIsValid = true;
		if (!fields["candidate_name"]) {
			formIsValid = false;
			errors["candidate_name"] = "This field is required.";
		}
		if (!fields["file-1"]) {
			formIsValid = false;
			errors["file-1"] = "This field is required.";
			this.setState({ invalid_ext: "" })
			this.setState({ invalid_profile: "" })
		}
		if ((fields["candidate_profiles"]) == 0) {
			formIsValid = false;
			errors["candidate_profiles"] = "This field is required.";
		}
		if (!fields["candidate_year"]) {
			formIsValid = false;
			errors["candidate_year"] = "This field is required.";
		}
		if (fields["candidate_year"] && !this.isValidNumber(fields["candidate_year"])) {
			formIsValid = false;
			errors["candidate_year"] = "Invalid Year.";
		}
		if (!fields["candidate_month"]) {
			formIsValid = false;
			errors["candidate_month"] = "This field is required.";
		}
		if (fields["candidate_month"] && (!this.isValidNumber(fields["candidate_month"]) || fields["candidate_month"] >= 12)) {
			formIsValid = false;
			errors["candidate_month"] = "Invalid Month.";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	isValidNumber(number) {
		var pattern = /^[0-9]+$/;
		//var pattern = /^[0-9]*\.?[0-9]*$/;
		return pattern.test(number);
	}

	link1Clicked() {
		let errors = {};
		errors["max_link"] = "Choose upto 3 links.";
		{ this.setState({ link2: 1 }) }
		{ this.state.link2 == 1 ? this.setState({ link3: 1 }) : this.setState({ link3: 0 }) }
		{ this.state.link3 == 1 ? this.setState({ errors: errors }) : '' }
	}

	link2Clicked() {
		let errors = {};
		errors["max_link"] = "";
		{ this.setState({ link3: 0 }) }
		{ this.state.link3 == 0 ? this.setState({ link2: 0 }) : '' }
		{ this.setState({ errors: errors }) }
	}

	link3Clicked() {
		let errors = {};
		errors["max_link"] = "";
		{ this.setState({ link3: 0 }) }
		{ this.setState({ errors: errors }) }
	}

	insertCandidate() {
		if (this.handleValidation()) {
			console.log("Data Has been submitted");
		} else {
			console.log("This Fields Are required.")
			return false;
		}
		document.getElementById("add_candidate").innerHTML = "Sending....";
		const fd = new FormData;

		let img = document.getElementById('files').files.length;
		if (img > 0) {
			for (var x = 0; x < img; x++) {
				fd.append("image[]", document.getElementById('files').files[x]);
			}
		}
		fd.append('hiring_inputs', JSON.stringify(this.state));
		fetch(this.state.apiUrl + '/HrmanagementRest/InsertCandidate/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
			method: 'POST',
			dataType: 'json',
			body: fd,
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				document.getElementById("add_candidate").innerHTML = "Submit";
				if (findresponse.code == 100) {
					window.location.href = '/hiring/';
				}
				else if (findresponse.code == 200) {
					this.setState({ invalid_ext: findresponse.msg }, function () { });
				}

			})
	}

	HiringList(page = 1) {
		fetch(this.state.apiUrl + '/HrmanagementRest/GetHiring/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				this.setState({
					manager_user: findresponse.manager_user,
					hiring_profile: findresponse.hiring_profile,
					hiring_status: findresponse.hiring_status,
					multiSelect: findresponse.multiSelect,
				})
			})
	}

	componentDidMount() {
		document.title = "Intranet | Add Candidate ";
		if (!localStorage.getItem('userLogin')) {
			this.setState({ redirect: true });
		}
		this.HiringList()
		$(document).ready(function () {
			if (window.File && window.FileList && window.FileReader) {
				$("#files").on("change", function (e) {
					var fi = document.getElementById('candidate_resume');
					var files = e.target.files,
						filesLength = files.length;
				});
			} else {
				alert("Your browser doesn't support to File API")
			}
		});
		$('.upload_btn label').click(function () {
			$('.upload_btn .inputfile').click();
		});
		$('.inputfile').each(function () {
			var $input = $(this),
				$label = $input.next('label'),
				labelVal = $label.html();

			$input.on('change', function (e) {
				var fileName = '';

				if (this.files && this.files.length > 1)
					fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
				else if (e.target.value)
					fileName = e.target.value.split('\\').pop();

				if (fileName)
					$label.find('span').html(fileName);
				else
					$label.html(labelVal);
			});

			// Firefox bug fix
			$input
				.on('focus', function () { $input.addClass('has-focus'); })
				.on('blur', function () { $input.removeClass('has-focus'); });
		});
	}

	render() {
		if (this.state.redirect) {
			return (
				<Redirect to={'/login'} />
			)
		}
		return (
			<div>
				<Header brecum_name="Hiring" brecum_page="Add Candidate" />
				<div class="right_col">
					<div class="intranet_body">
						<div class="title mob"><HeaderMob page_name="Add Candidate" /></div>
						<div class="top-row-form row">
							<div class="col-md-6 col-xs-12">
								<div class="form-group">
									<label for="staticEmail" class="col-form-label">Name</label>
									<div class="">
										<input type="text" name="candidate_name" placeholder="Enter Candidate Name" class="form-control" onKeyPress={this.spaceKeyPress} onChange={this.onChange} />
										<span class="error">{this.state.errors["candidate_name"]}</span>
									</div>
								</div>
								<div class="form-group margin_bottom_less padding_bottom_less">
									<label for="inputPassword" class="col-form-label">Years Of Experience</label>
									<div class="row">
										<div class="col-sm-6 col-xs-12 form-group">
											<input type="text" name="candidate_year" placeholder="Year" onKeyPress={this.spaceKeyPress} class="form-control" onChange={this.onChange} />
											<span class="error">{this.state.errors["candidate_year"]}</span>
										</div>
										<div class="col-sm-6 col-xs-12 form-group">
											<input type="text" name="candidate_month" placeholder="Month" onKeyPress={this.spaceKeyPress} class="form-control" onChange={this.onChange} />
											<span class="error">{this.state.errors["candidate_month"]}</span>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label for="staticEmail" class="col-form-label">Status</label>
									<div class="">
										<select class="form-control" name="candidate_status" onChange={this.onChange}>
											<option value="">Select Status</option>
											{
												this.state.hiring_status.map((hiring_status, key) =>
													<option value={hiring_status.status}>{hiring_status.status}</option>
												)
											}
										</select>
									</div>
								</div>
								<div class="form-group upload">
									<label>Resume</label>
									<div class="upload_btn">
										<input type="file" name="file-1" id="files" class="inputfile inputfile-1" onChange={this.onChange} data-multiple-caption="{count} files selected" />
										<label for="file-1">
											<i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
											<span>Choose file</span>
											<i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
										</label>

									</div>
									<span class="error">{this.state.errors["file-1"]}</span>
									<span class="error">{this.state.invalid_ext}</span>
								</div>
								<div class="form-group" >
									<label for="staticEmail" class="col-form-label">Notes</label>
									<div class="">
										<textarea type="text" name="candidate_notes" placeholder="" class="form-control" onKeyPress={this.spaceKeyPress} onChange={this.onChange}></textarea>
									</div>
								</div>
							</div>
							<div class="col-md-6 col-xs-12">
								<div class="form-group">
									<label for="staticEmail" class="col-form-label">Profile</label>
									<div class="selectOptions">
										<MuiThemeProvider muiTheme={getMuiTheme()}>
											<SelectField
												multiple
												fullWidth={true}
												value={this.state.value}
												onChange={this.handleChange}
												maxHeight={200}
												className="multi"
											>
												{this.state.hiring_profile.map((profile, i) =>
													<MenuItem
													className="multi_drop"
														value={profile.id} key={profile.id} primaryText={profile.name} />)}
											</SelectField>
										</MuiThemeProvider>
									</div>
									<span class="error">{this.state.errors["candidate_profiles"]}</span>
								</div>
								<div class="form-group">
									<label for="inputPassword" class="col-form-label">Social Media Links</label>
									<input type="text" name="candidate_links" placeholder="Add Link Here" class="links form-control" onChange={this.onLinkChange} />
									<button class="form-icon" id="" onClick={() => this.link1Clicked()} type="button">+</button>
								</div>
								{this.state.link2 == 1 ?
									<div class="form-group">
										<label for="inputPassword" class="col-form-label"></label>
											<input type="text" name="candidate_links" placeholder="Add Link Here" class="links form-control" onChange={this.onLinkChange} />
											<button class="form-icon" id="" onClick={() => this.link2Clicked()} type="button">-</button>
										
									</div>
									: ''}
								{this.state.link3 == 1 ? 
								<div class="form-group">
									<label for="inputPassword" class="col-form-label"></label>
										<input type="text" name="candidate_links" placeholder="Add Link Here" class="links form-control" onChange={this.onLinkChange} />
										<button class="form-icon" id="" onClick={() => this.link3Clicked()} type="button">-</button>
										<span class="error">{this.state.errors["max_link"]}</span>
								</div> : ''}
								<div class="form-group">
									<label for="staticEmail" class="col-form-label">Interviewer</label>
									<select class="form-control" name="candidate_interviewer" onChange={this.onChange}>
										<option value="">Select Interviewer</option>
										{
											this.state.manager_user.map((manager_user, key) =>
												<option value={manager_user.id}>{manager_user.name}</option>
											)
										}
									</select>
									<span class="error">{this.state.errors["candidate_interviewer"]}</span>
								</div>
							</div>
						</div>
						<button type="submit" name="add_candidate" id="add_candidate" class="btn btn-sky mob-btn" onClick={() => this.insertCandidate()}>Submit</button>
						<Link to={`/hiring/`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
					</div>
				</div>
			</div>
		)
	}
}
export default AddCandidate;


// WEBPACK FOOTER //
// ./src/components/hiring/addCandidate.js